export default {
    NotificacaoConfiguracao: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "notificacoes-configuracao"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/NotificacaoConfiguracao.js
// module id = MNmk
// module chunks = 32